<template>
  <b-container class="p-0">
    <b-card>
      <b-row class="justify-content-between container">
        <b-col
          sm="12"
          md="6"
          xl="auto"
        >
          <h6> CEP: </h6>
          <p> {{ address.postal_code | postalCode }} </p>
        </b-col>

        <b-col
          sm="12"
          md="6"
          xl="auto"
        >
          <h6> Estado: </h6>
          <p> {{ address.state }} </p>
        </b-col>

        <b-col
          sm="12"
          md="6"
          xl="auto"
        >
          <h6> Cidade: </h6>
          <p> {{ address.city }} </p>
        </b-col>

        <b-col
          sm="12"
          md="6"
          xl="auto"
        >
          <h6> Bairro: </h6>
          <p> {{ address.district }} </p>
        </b-col>

        <b-col
          sm="12"
          md="6"
          xl="auto"
        >
          <h6> Endereco: </h6>
          <p> {{ address.address }}, {{ address.number }} </p>
        </b-col>

        <b-col
          v-if="address.complement"
          sm="12"
          md="6"
          xl="auto"
        >
          <h6> Complemento: </h6>
          <p> {{ address.complement }} </p>
        </b-col>

        <b-col
          v-if="address.phone"
          sm="12"
          md="6"
          xl="auto"
          class="mr-auto"
        >
          <h6> Telefone: </h6>
          <p> {{ address.phone }} </p>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
  },
  filters: {
    postalCode: value => {
      if (!value) return value
      if (value.length === 8) {
        const result = [value.slice(0, 5), value.slice(5, 8)]
        return `${result[0]}-${result[1]}`
      }

      return value
    },
  },
  props: ['address'],
}

</script>

<style lang="scss">

</style>
